import { NgModule } from '@angular/core';
import { PrizmWidgetComponent } from './widget.component';

@NgModule({
  imports: [PrizmWidgetComponent],
  exports: [PrizmWidgetComponent],
})
export class PrizmWidgetModule {}
